import { render, staticRenderFns } from "./ExtendedCard.vue?vue&type=template&id=176e6e37"
import script from "./ExtendedCard.vue?vue&type=script&lang=js"
export * from "./ExtendedCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports